import Text from '~/components/Text';
import { useEstimateListContext } from '../hooks/useEstimateListContext';
import * as Styles from './styles';
import { fmPrice } from '~/utils/amount';
import Gap from '~/components/Gap';
import EstimateStatusPills from '../CellContent/EstimateStatusPills';
import { formatDate } from '~/utils/datetime';
import EstimateContextMenu from '../CellContent/EstimateContextMenu';
import EstimateDueStatus from '../EstimateDueStatus';

const EstimateList = () => {
  const { listIds, maxListItems, listData, onOpenViewEstimateModal } = useEstimateListContext();
  return (
    <div>
      <ul>
        {listIds.slice(0, maxListItems ?? listIds.length).map(estimateId => {
          const thisEstimateData = listData[estimateId];
          const formattedDate = thisEstimateData.estimate_date
            ? formatDate(thisEstimateData.estimate_date)
            : null;

          return (
            <Styles.ListItem key={estimateId}>
              <Styles.LeftContainer
                onClick={() => {
                  onOpenViewEstimateModal(thisEstimateData.estimate_uuid);
                }}
              >
                <Text size="xsmd" className="bold">
                  {thisEstimateData.estimate_number}
                </Text>
                <Gap t={3} />
                <Text size="xsmd" variant="secondary">
                  {thisEstimateData.buyer_company_name}
                </Text>
                <Gap t={3} />
                <Text size="xxsmd" variant="neutral">
                  {formattedDate}
                </Text>
              </Styles.LeftContainer>

              <Styles.RightContainer>
                <div className="d-flex">
                  <div>
                    <Text className="bold" align="right">
                      {fmPrice(thisEstimateData.currency, thisEstimateData.total_amount)}
                    </Text>
                    <Gap t={4} />
                    <div className="full-width end-align-center">
                      <EstimateStatusPills estimateData={thisEstimateData} />
                    </div>
                    <Gap t={4} />
                    <div className="end-align-center">
                      <EstimateDueStatus estimateData={thisEstimateData} />
                    </div>
                  </div>
                  <Gap l={8} />
                  <EstimateContextMenu estimateReferenceId={estimateId} />
                </div>
              </Styles.RightContainer>
            </Styles.ListItem>
          );
        })}
      </ul>
    </div>
  );
};

export default EstimateList;
